module.exports = __webpack_public_path__ + "static/media/service-start.3a9a355b.svg";